/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r3'">R3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 (R1 + R2) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">OSPF Router IDs</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/8</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2']" :key="'t1-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in (rKey==='r1'?task1R1Items:task1R2Items)" :key="rKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey)[item.key]?'text-success':''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 (R2 only) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">OSPF Priority — R2 becomes DR</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Items.filter(i=>r2Completion[i.key]).length }}/{{ task2Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r2Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(r2Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 3 (R1 + R2 + R3 + verify) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">Advertise Loopback Networks</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/5</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2','r3']" :key="'t3-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in (rKey==='r1'?task3R1Items:rKey==='r2'?task3R2Items:task3R3Items)" :key="rKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey)[item.key]?'text-success':''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
              <div class="mt-1">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R3</span>
                <div class="space-y-1 ml-1 mt-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r3Completion.showRouteOspf?'#28C76F':'transparent',border:'2px solid '+(r3Completion.showRouteOspf?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="r3Completion.showRouteOspf?'text-success':''">show ip route ospf</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 (R1 + R3 + verify) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">Point-to-Point on R1–R3 Link</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/5</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r3']" :key="'t4-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task4Items" :key="rKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey)[item.key]?'text-success':''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
              <div class="mt-1">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R3</span>
                <div class="space-y-1 ml-1 mt-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r3Completion.showOspfNeighbor?'#28C76F':'transparent',border:'2px solid '+(r3Completion.showOspfNeighbor?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="r3Completion.showOspfNeighbor?'text-success':''">show ip ospf neighbor</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r3'" key="r3" id="r3_terminal" :commands="r3Commands" :prompt="r3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R3" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const mkCommands = (rk, vm) => ({
  help:          () => createStdout(HELP),
  enable:        () => createStdout(''),
  configure:     (x) => vm.iosConfigure(rk, x),
  conf:          (x) => vm.iosConfigure(rk, x),
  exit:          () => vm.iosExit(rk),
  end:           () => vm.iosEnd(rk),
  router:        (x) => vm.iosRouter(rk, x),
  'router-id':   (x) => vm.iosRouterId(rk, x),
  network:       (x) => vm.iosNetwork(rk, x),
  ip:            (x) => vm.iosIp(rk, x),
  interface:     (x) => vm.iosInterface(rk, x),
  int:           (x) => vm.iosInterface(rk, x),
  clear:         (x) => vm.iosClear(rk, x),
  show:          (x) => vm.iosShow(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/OSPF_Configuration.png',
      sel: 'r1',
      totalScore: 0,

      task1R1Items: [
        { key: 'routerOspf', cmd: 'router ospf 1' },
        { key: 'routerId',   cmd: 'router-id 10.10.12.1' },
        { key: 'clearOspf',  cmd: 'clear ip ospf process' },
        { key: 'showOspf',   cmd: 'show ip ospf' },
      ],
      task1R2Items: [
        { key: 'routerOspf',  cmd: 'router ospf 1' },
        { key: 'routerId',    cmd: 'router-id 10.10.12.2' },
        { key: 'clearOspfT1', cmd: 'clear ip ospf process' },
        { key: 'showOspfT1',  cmd: 'show ip ospf' },
      ],
      task2Items: [
        { key: 'intE00',        cmd: 'interface e0/0' },
        { key: 'ospfPriE00',    cmd: 'ip ospf priority 255' },
        { key: 'intE02',        cmd: 'interface e0/2' },
        { key: 'ospfPriE02',    cmd: 'ip ospf priority 255' },
        { key: 'clearOspfT2',   cmd: 'clear ip ospf process' },
        { key: 'showOspfNeighbor', cmd: 'show ip ospf neighbor' },
      ],
      task3R1Items: [
        { key: 'routerOspfT3',   cmd: 'router ospf 1' },
        { key: 'networkLoopback',cmd: 'network 192.168.1.1 0.0.0.0 area 0' },
      ],
      task3R2Items: [
        { key: 'routerOspfT3',   cmd: 'router ospf 1' },
        { key: 'networkLoopback',cmd: 'network 192.168.2.2 0.0.0.0 area 0' },
      ],
      task3R3Items: [
        { key: 'routerOspf',     cmd: 'router ospf 1' },
        { key: 'networkLoopback',cmd: 'network 192.168.3.3 0.0.0.0 area 0' },
      ],
      task4Items: [
        { key: 'intE01',     cmd: 'interface e0/1' },
        { key: 'ptpNetwork', cmd: 'ip ospf network point-to-point' },
      ],

      r1: { mode: 'exec', currentInterface: null },
      r2: { mode: 'exec', currentInterface: null },
      r3: { mode: 'exec', currentInterface: null },

      r1Completion: {
        routerOspf: false, routerId: false, clearOspf: false, showOspf: false,
        networkLoopback: false, intE01: false, ptpNetwork: false,
        routerOspfT3: false, // display-only: Task 3 re-entry of "router ospf 1" (not scored)
      },
      r2Completion: {
        routerOspf: false, routerId: false, clearOspfT1: false, showOspfT1: false,
        intE00: false, ospfPriE00: false, intE02: false, ospfPriE02: false,
        clearOspfT2: false, showOspfNeighbor: false, networkLoopback: false,
        routerOspfT3: false, // display-only: Task 3 re-entry of "router ospf 1" (not scored)
      },
      r3Completion: {
        routerOspf: false, networkLoopback: false, showRouteOspf: false,
        intE01: false, ptpNetwork: false, showOspfNeighbor: false,
      },

      r1Commands: null,
      r2Commands: null,
      r3Commands: null,
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'config') return 'R1(config)#';
      if (m === 'config-router') return 'R1(config-router)#';
      if (m === 'config-if') return 'R1(config-if)#';
      return 'R1#';
    },
    r2Prompt() {
      const m = this.r2.mode;
      if (m === 'config') return 'R2(config)#';
      if (m === 'config-router') return 'R2(config-router)#';
      if (m === 'config-if') return 'R2(config-if)#';
      return 'R2#';
    },
    r3Prompt() {
      const m = this.r3.mode;
      if (m === 'config') return 'R3(config)#';
      if (m === 'config-router') return 'R3(config-router)#';
      if (m === 'config-if') return 'R3(config-if)#';
      return 'R3#';
    },
    task1Progress() {
      const keys = ['routerOspf','routerId','clearOspf','showOspf'];
      const r2keys = ['routerOspf','routerId','clearOspfT1','showOspfT1'];
      return keys.filter(k => this.r1Completion[k]).length + r2keys.filter(k => this.r2Completion[k]).length;
    },
    task1Done() {
      return this.r1Completion.showOspf &&
             this.r2Completion.routerOspf && this.r2Completion.routerId &&
             this.r2Completion.clearOspfT1 && this.r2Completion.showOspfT1;
    },
    task2Done() {
      return ['intE00','ospfPriE00','intE02','ospfPriE02','clearOspfT2','showOspfNeighbor'].every(k => this.r2Completion[k]);
    },
    task3Progress() {
      return (this.r1Completion.networkLoopback ? 1 : 0) +
             (this.r2Completion.networkLoopback ? 1 : 0) +
             (this.r3Completion.routerOspf ? 1 : 0) +
             (this.r3Completion.networkLoopback ? 1 : 0) +
             (this.r3Completion.showRouteOspf ? 1 : 0);
    },
    task3Done() {
      return this.r1Completion.networkLoopback && this.r2Completion.networkLoopback &&
             this.r3Completion.routerOspf && this.r3Completion.networkLoopback && this.r3Completion.showRouteOspf;
    },
    task4Progress() {
      return (this.r1Completion.intE01 ? 1 : 0) + (this.r1Completion.ptpNetwork ? 1 : 0) +
             (this.r3Completion.intE01 ? 1 : 0) + (this.r3Completion.ptpNetwork ? 1 : 0) +
             (this.r3Completion.showOspfNeighbor ? 1 : 0);
    },
    task4Done() {
      return this.r1Completion.ptpNetwork && this.r3Completion.ptpNetwork && this.r3Completion.showOspfNeighbor;
    },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
    this.r3Commands = mkCommands('r3', this);
  },

  methods: {
    getState(k) { return this[k]; },
    getCompletion(k) { return this[k + 'Completion']; },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') {
        if (state.mode === 'exec') return createStderr('% Must be in configuration mode — type "configure terminal" first');
        return createStderr('% Must be in configuration mode — type "exit" to leave current submode first');
      }
      if (needed === 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      if (needed === 'config-router') return createStderr('% Must be in router config mode — type "router ospf 1" first');
      if (needed === 'config-if') return createStderr('% Must be in interface config mode — enter an interface first');
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      // routerOspfT3 is a display-only flag for the Task 3 re-entry of "router ospf 1" — not scored.
      [this.r1Completion, this.r2Completion, this.r3Completion].forEach(c => Object.entries(c).forEach(([k, v]) => { if (v && k !== 'routerOspfT3') score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 24) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosConfigure(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[rk].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      const s = this[rk];
      if (s.mode === 'config-router' || s.mode === 'config-if') s.mode = 'config';
      else if (s.mode === 'config') s.mode = 'exec';
      return createStdout('');
    },

    iosEnd(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosRouter(rk, x) {
      const me = this.modeErr(this[rk], 'config'); if (me) return me;
      if (x._[1] === 'ospf') {
        this[rk].mode = 'config-router';
        const c = this[rk + 'Completion'];
        if (!c.routerOspf) {
          c.routerOspf = true; this.updateScore();
          return createStdout(this.guide('Entered OSPF process 1. The process number is locally significant — it doesn\'t need to match between routers. → Next: set the Router ID.'));
        }
        // Re-entry (Task 3): mark the Task 3 "router ospf 1" step only now, not back in Task 1
        if ('routerOspfT3' in c && !c.routerOspfT3) { c.routerOspfT3 = true; this.updateScore(); }
        return createStdout(this.guide('Back in OSPF config mode. → Next: add the network statement.'));
      }
      return createStderr('% Invalid input detected');
    },

    iosRouterId(rk, x) {
      const me = this.modeErr(this[rk], 'config-router'); if (me) return me;
      const c = this[rk + 'Completion'];
      const expectedId = rk === 'r1' ? '10.10.12.1' : '10.10.12.2';
      if (!c.routerId) {
        c.routerId = true; this.updateScore();
        return createStdout(this.guide(`Router ID set to ${expectedId} — the shared link IP between R1 and R2. Manual IDs prevent OSPF from auto-selecting a potentially changing address. → Next: "end" then "clear ip ospf process" to apply the new ID.`));
      }
      return createStdout('');
    },

    iosNetwork(rk, x) {
      const me = this.modeErr(this[rk], 'config-router'); if (me) return me;
      const c = this[rk + 'Completion'];
      if (x._[2] === '0.0.0.0' && !c.networkLoopback) {
        c.networkLoopback = true; this.updateScore();
        const loopMap = { r1: '192.168.1.1', r2: '192.168.2.2', r3: '192.168.3.3' };
        return createStdout(this.guide(`Loopback1 (${loopMap[rk]}) advertised into OSPF area 0. Wildcard 0.0.0.0 = exact /32 host match — only this specific address is announced. OSPF will propagate it to all neighbors. ` + (rk === 'r3' ? '→ Next: "end" then "show ip route ospf" to verify all three loopbacks appear.' : '→ Proceed to next router.')));
      }
      return createStdout('');
    },

    iosIp(rk, x) {
      const s = this[rk]; const c = this[rk + 'Completion'];
      if (x._[1] === 'ospf' && x._[2] === 'priority') {
        const me = this.modeErr(s, 'config-if'); if (me) return me;
        const iface = s.currentInterface;
        if (iface === 'e0/0' && 'ospfPriE00' in c && !c.ospfPriE00) {
          c.ospfPriE00 = true; this.updateScore();
          return createStdout(this.guide('OSPF priority 255 set on e0/0 (R1-facing link). Priority 255 = maximum — R2 will always win the DR election on this broadcast segment. Default priority is 1; 0 means a router will never become DR. → Next: set the same on e0/2 (R3-facing).'));
        }
        if (iface === 'e0/2' && 'ospfPriE02' in c && !c.ospfPriE02) {
          c.ospfPriE02 = true; this.updateScore();
          return createStdout(this.guide('Priority 255 set on e0/2 (R3-facing link) too. R2 now wins DR election on both segments. R1 and R3 keep default priority 1, making them BDRs. → Next: "end" then "clear ip ospf process" to trigger DR re-election, then verify with "show ip ospf neighbor".'));
        }
        return createStdout('');
      }
      if (x._[1] === 'ospf' && x._[2] === 'network' && (x._[3] || '').includes('point')) {
        const me = this.modeErr(s, 'config-if'); if (me) return me;
        if (!c.ptpNetwork) {
          c.ptpNetwork = true; this.updateScore();
          return createStdout(this.guide('Link changed to point-to-point type. P2P networks skip DR/BDR election entirely — exactly two endpoints, no election overhead, adjacency forms faster. On p2p links OSPF priority becomes irrelevant (shows as 0 in "show ip ospf neighbor"). → ' + (rk === 'r1' ? 'Do the same on R3.' : 'Verify on R3 with "show ip ospf neighbor".')));
        }
        return createStdout('');
      }
      return createStderr('% Invalid input detected');
    },

    iosInterface(rk, x) {
      const s = this[rk]; const c = this[rk + 'Completion'];
      if (s.mode !== 'config' && s.mode !== 'config-if') return this.modeErr(s, 'config');
      let _r1 = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _r1 = _r1 + x._[2];
      const raw = _r1.toLowerCase().replace(/^(ethernet|e|fastethernet|fa|f|gigabitethernet|gi)/, 'e')
      s.mode = 'config-if'; s.currentInterface = raw;
      if (raw === 'e0/0' && 'intE00' in c && !c.intE00) {
        c.intE00 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/0 — R2\'s interface facing R1. OSPF priority is set per-interface to control which router wins DR election on each broadcast segment. → Next: ip ospf priority 255'));
      }
      if (raw === 'e0/2' && 'intE02' in c && !c.intE02) {
        c.intE02 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/2 — R2\'s interface facing R3. Setting priority 255 here too makes R2 the DR on both of its segments simultaneously. → Next: ip ospf priority 255'));
      }
      if (raw === 'e0/1' && 'intE01' in c && !c.intE01) {
        c.intE01 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/1 — the link connecting R1 and R3. Currently a broadcast network type which would run DR/BDR election even with just two routers on the segment. → Next: ip ospf network point-to-point'));
      }
      return createStdout('');
    },

    iosClear(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      if (x._[1] === 'ip' && x._[2] === 'ospf') {
        const c = this[rk + 'Completion'];
        const out = 'Reset ALL OSPF processes? [no]: y<br>%OSPF-5-ADJCHG: Process 1, Nbr changed, Adjacency forced to reset';
        // R1 — single clearOspf flag
        if ('clearOspf' in c && !c.clearOspf) {
          c.clearOspf = true; this.updateScore();
          return createStdout(out + this.guide('OSPF process reset on R1. OSPF will re-establish adjacencies using Router ID 10.10.12.1. → Next: "show ip ospf" to confirm the new ID.'));
        }
        // R2 — T1 first, then T2 after priority configured
        if ('clearOspfT1' in c) {
          if (!c.clearOspfT1) {
            c.clearOspfT1 = true; this.updateScore();
            return createStdout(out + this.guide('OSPF process reset on R2. R2 will re-establish adjacencies using Router ID 10.10.12.2. → Next: "show ip ospf" to confirm.'));
          }
          if (c.ospfPriE02 && !c.clearOspfT2) {
            c.clearOspfT2 = true; this.updateScore();
            return createStdout(out + this.guide('OSPF process reset on R2. DR re-election will occur using the new priority 255 values. → Next: "show ip ospf neighbor" to confirm R2 is the DR.'));
          }
        }
        return createStdout(out);
      }
      return createStderr('% Invalid input detected');
    },

    iosShow(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      const c = this[rk + 'Completion'];

      // show ip ospf (no further args) — Task 1 verification
      if (x._[1] === 'ip' && x._[2] === 'ospf' && !x._[3]) {
        const idMap = { r1: '10.10.12.1', r2: '10.10.12.2', r3: '192.168.3.3' };
        if ('showOspf' in c && !c.showOspf) { c.showOspf = true; this.updateScore(); }
        if ('showOspfT1' in c && !c.showOspfT1) { c.showOspfT1 = true; this.updateScore(); }
        return createStdout(
          `Routing Process "ospf 1" with ID ${idMap[rk]}<br> Start time: 00:00:00.100, Time elapsed: 00:15:42<br> ...` +
          this.guide(`Router ID confirmed: ${idMap[rk]}. This ID uniquely identifies ${rk.toUpperCase()} in the OSPF domain. ` + (rk === 'r1' ? '→ Switch to R2 for Task 1 verification.' : '→ Now configure Task 2 — set OSPF priority on R2 interfaces.')),
        );
      }

      // show ip ospf neighbor — Task 2/4 verification
      if (x._[1] === 'ip' && x._[2] === 'ospf' && x._[3] === 'neighbor') {
        let out = 'Neighbor ID&nbsp;&nbsp;&nbsp;&nbsp;Pri&nbsp;&nbsp;State&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dead Time&nbsp;&nbsp;Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Interface<br>';
        let guidance = '';
        if (rk === 'r2') {
          out += '10.10.12.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;FULL/BDR&nbsp;&nbsp;00:00:39&nbsp;&nbsp;&nbsp;10.10.12.1&nbsp;&nbsp;&nbsp;Ethernet0/0<br>' +
                 '192.168.3.3&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;FULL/BDR&nbsp;&nbsp;00:00:39&nbsp;&nbsp;&nbsp;10.10.23.3&nbsp;&nbsp;&nbsp;Ethernet0/2<br>';
          if (!c.showOspfNeighbor) { c.showOspfNeighbor = true; this.updateScore(); }
          guidance = 'Both neighbors show as BDR — confirming R2 is the DR on both segments. Priority 255 won the DR election. → Move to Task 3: advertise loopback networks.';
        }
        if (rk === 'r3') {
          out += '10.10.12.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0&nbsp;&nbsp;&nbsp;&nbsp;FULL/ -&nbsp;&nbsp;&nbsp;00:00:39&nbsp;&nbsp;&nbsp;10.10.13.1&nbsp;&nbsp;&nbsp;GigabitEthernet0/1<br>' +
                 '10.10.12.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;255&nbsp;&nbsp;FULL/DR&nbsp;&nbsp;&nbsp;00:00:30&nbsp;&nbsp;&nbsp;10.10.23.2&nbsp;&nbsp;&nbsp;GigabitEthernet0/2<br>';
          if (!c.showOspfNeighbor) { c.showOspfNeighbor = true; this.updateScore(); }
          guidance = 'R1 shows "FULL/ -" (no DR/BDR on point-to-point segment, priority 0). R2 shows "FULL/DR" (still a broadcast segment). Point-to-point configuration confirmed. → Save all three routers.';
        }
        return createStdout(out + this.guide(guidance));
      }

      // show ip route ospf — Task 3 verification
      if (x._[1] === 'ip' && x._[2] === 'route' && x._[3] === 'ospf') {
        const out =
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.0.0/8 is variably subnetted<br>' +
          'O&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.10.12.0 [110/2] via 10.10.13.1, Ethernet0/1<br>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;192.168.1.0/32 is subnetted, 1 subnets<br>' +
          'O&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;192.168.1.1 [110/2] via 10.10.13.1, Ethernet0/1<br>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;192.168.2.0/32 is subnetted, 1 subnets<br>' +
          'O&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;192.168.2.2 [110/2] via 10.10.23.2, Ethernet0/2<br>';
        if ('showRouteOspf' in c && !c.showRouteOspf) { c.showRouteOspf = true; this.updateScore(); }
        return createStdout(out + this.guide('R3 sees 192.168.1.1 (R1\'s loopback) and 192.168.2.2 (R2\'s loopback) via OSPF — both learned successfully. All three loopbacks are now reachable across the OSPF domain. → Move to Task 4: configure point-to-point on the R1–R3 link.'));
      }

      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal, #r3_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

